import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LANDING_CONTENT } from "../content";
import { PhotoSlot } from "./PhotoSlot";
import { Reveal } from "./Reveal";
import { Section, SectionHeading, SectionLead } from "./Section";

// The second product line, kept to ONE section (ADR-0055): the 3D print
// ("obraz 3D"). The pillow stays the hero of the whole page; this introduces the
// print as a real add-on, on a soft coral-tinted band so it reads as its own beat
// without competing with the pillow narrative.
export function Print3d() {
  const { t } = useTranslation("landing");
  return (
    <Section id="print3d" labelledBy="print3d-heading" className="bg-[hsl(12_60%_97%)]">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
        <Reveal delayMs={100} className="lg:order-2">
          <PhotoSlot
            image={LANDING_CONTENT.print3d}
            alt={t("print3d.imageAlt")}
            briefId="print3d"
            aspectClassName="aspect-square"
            icon={Sparkles}
            label={t("print3d.imagePlaceholder")}
          />
        </Reveal>
        <Reveal className="lg:order-1">
          <div className="max-w-lg">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/15 px-3 py-1 text-xs font-semibold text-primary">
              <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
              {t("print3d.badge")}
            </span>
            <SectionHeading id="print3d-heading" className="mt-4">
              {t("print3d.heading")}
            </SectionHeading>
            <SectionLead className="mt-4">{t("print3d.lead")}</SectionLead>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
